<div
  class="fixed inset-0 z-50 flex items-center justify-center p-4"
  style="background: rgba(0, 0, 0, 0.45)"
  (click)="close.emit()"
>
  <div
    class="flex w-full max-w-[460px] flex-col overflow-hidden rounded-2xl bg-white shadow-2xl"
    style="max-height: 88vh; border: 1px solid var(--app-border)"
    role="dialog"
    aria-modal="true"
    aria-labelledby="supervisor-dialog-title"
    (click)="$event.stopPropagation()"
  >
    <!-- Header -->
    <div
      class="flex shrink-0 items-center justify-between px-5 py-3.5"
      style="border-bottom: 1px solid var(--app-border)"
    >
      <h2
        id="supervisor-dialog-title"
        class="flex items-center gap-2 text-[14px] font-semibold text-gray-900"
      >
        <lucide-icon [img]="icons.KeyRound" [size]="15" class="text-gray-500" />
        Código de regente
      </h2>
      <button
        type="button"
        (click)="close.emit()"
        class="flex h-8 w-8 cursor-pointer items-center justify-center rounded-lg text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-700"
        title="Cerrar"
      >
        <lucide-icon [img]="icons.X" [size]="16" />
      </button>
    </div>

    <!-- El código -->
    <div class="flex shrink-0 flex-col items-center gap-3 px-6 py-7">
      @if (loading()) {
        <div class="py-6 text-sm text-gray-400">Cargando…</div>
      } @else if (stale()) {
        <!-- Sin número: lo que había ya no es el de esta hora, y un botón en
             su sitio no puede estar equivocado. -->
        <button
          type="button"
          (click)="refreshCode()"
          class="my-2 inline-flex cursor-pointer items-center gap-2 rounded-xl bg-blue-600 px-6 py-3.5 text-[15px] font-semibold text-white transition-colors hover:bg-blue-700"
        >
          <lucide-icon [img]="icons.RefreshCw" [size]="16" />
          Mostrar mi código
        </button>

        @if (failed()) {
          <p class="text-[13px] font-medium text-red-600">
            No se pudo consultar. Vuelve a intentarlo.
          </p>
        } @else {
          <p class="max-w-[360px] text-center text-[13px] text-gray-500">
            El código cambió de hora. El anterior sigue sirviendo un rato, así que nadie se queda a
            medias.
          </p>
        }
      } @else {
        <div
          class="font-mono text-[52px] leading-none font-bold tracking-[0.18em] text-gray-900 tabular-nums"
        >
          {{ code() }}
        </div>

        <p class="text-[13px] text-gray-500">
          Cambia en <span class="font-semibold text-gray-700 tabular-nums">{{ countdown }}</span>
        </p>
      }
    </div>

    <div
      class="shrink-0 bg-gray-50 px-6 py-3"
      style="border-top: 1px solid var(--app-border); border-bottom: 1px solid var(--app-border)"
    >
      <p class="text-center text-[12.5px] leading-relaxed text-gray-500">
        Dicta estos cuatro dígitos en el mostrador para aprobar o denegar una línea de alto costo.
        Nadie más que tú los ve.
      </p>
    </div>

    <!-- Lo que se ha preguntado -->
    <div class="min-h-0 flex-1 overflow-y-auto px-5 pt-4 pb-5">
      <h3 class="mb-2.5 text-[12.5px] font-semibold text-gray-700">Últimas autorizaciones</h3>

      @if (loading()) {
        <div class="py-6 text-center text-sm text-gray-400">Cargando…</div>
      } @else if (checks().length === 0) {
        <p class="py-4 text-center text-[13px] text-gray-500">
          Todavía no te han pedido autorizar nada.
        </p>
      } @else {
        <div class="flex flex-col divide-y divide-gray-100">
          @for (check of checks(); track check.id) {
            <div class="flex items-start justify-between gap-3 py-2.5">
              <div class="min-w-0">
                <p class="truncate text-[13px] font-semibold text-gray-900">
                  {{ check.article_name || check.article_code || '—' }}
                </p>
                <p class="mt-0.5 text-[11.5px] text-gray-500">
                  @if (check.cost_total) {
                    <span class="font-semibold text-gray-700"
                      >${{ check.cost_total | number: '1.0-0' }}</span
                    >
                    @if (source(check)) {
                      · {{ source(check) }}
                    }
                    ·
                  }
                  {{ check.created_at | date: 'short' }}
                  @if (check.by_name) {
                    · {{ check.by_name }}
                  }
                </p>
                @if (check.reason) {
                  <p class="mt-1 text-[11.5px] text-gray-600">{{ check.reason }}</p>
                }
              </div>
              <span
                class="inline-flex shrink-0 items-center rounded-md px-2 py-0.5 text-[10.5px] font-semibold"
                [class]="outcome(check).classes"
              >
                {{ outcome(check).label }}
              </span>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
